import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  TextAreaInput,
  TextInputField,
  TextInputFieldSearch,
} from "../../../../../../components/atoms";
import DropDownButton from "../../../../../../components/drop-down-button/DropDownButton";
import { DropDownWithButton } from "../../../../../../components";
import PosPatientCard from "../../../patient-display/PosPatientCard";

const SupportModal = ({
  display,
  setSupportModalPopUp,
  user,
  OnUserSearch,
  search,
  setSearch,
  customers,
  setCustomers,
  setToastPop,
  setMessage,
  setLoading,
  setRefresh,
  refresh,
}) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedIssueType, setSelectedIssueType] = useState(
    "CLICK HERE TO SELECT TYPE OF ISSUE"
  );
  const [selectedBugType, setSelectedBugType] = useState(
    "CLICK HERE TO SELECT SECTION WITH BUG"
  );

  const ClearData = () => {
    setSelectedBugType("CLICK HERE TO SELECT SECTION WITH BUG");
    setSelectedIssueType("CLICK HERE TO SELECT TYPE OF ISSUE");
    setSelectedUser(null);
    setIssueDescription("");
    setBugBreakDown("");
  };

  const [issueDescription, setIssueDescription] = useState("");
  const [bugBreakDown, setBugBreakDown] = useState("");

  const SubmitSupportTicketHandler = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://merry-jane-api.onrender.com/support/createSupportTicket",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            systemUser: user.firstName + " " + user.lastName,
            storeName: user.storeName,
            issueType: selectedIssueType,
            issueDescription: issueDescription,
            selectedUserId: selectedUser ? selectedUser._id : user.userId,
            section:
              selectedBugType !== "CLICK HERE TO SELECT SECTION WITH BUG"
                ? selectedBugType
                : "none",
            sectionErrorDescription:
              selectedBugType !== "CLICK HERE TO SELECT SECTION WITH BUG"
                ? bugBreakDown
                : "none",
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setMessage(responseData.success);
        setToastPop(true);
        setSupportModalPopUp(false);
        ClearData();
        setLoading(false);
        setRefresh(refresh ? false : true);
      } else {
        setMessage(responseData.error);
        setToastPop(true);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: BlackAndWhite.secondary,
        position: "absolute",
        overflow: "hidden",
        transition: "all 0.3s",
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div style={{ position: "absolute", left: 20, top: 20 }}>
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"BACK"}
          borderRadius={8}
          onClick={() => {
            setSupportModalPopUp(false);
            ClearData();
          }}
          height={35}
          size={100}
        />
      </div>
      <div
        style={{
          flex: 1,
          height: "95%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
        }}
      >
        <div style={{ minHeight: 80 }}></div>
        <TextInputField
          mini={true}
          labelTitle={"SYSTEM USER ( AUTO GENERATED )"}
          invert={true}
          width={"100%"}
          size={"75%"}
          readOnly={true}
          value={user ? user.firstName + " " + user.lastName : "loading"}
        />
        <div style={{ height: 25 }}></div>
        <TextInputField
          mini={true}
          labelTitle={"STORE NAME ( AUTO GENERATED )"}
          invert={true}
          width={"100%"}
          size={"75%"}
          readOnly={true}
          value={user ? user.storeName : "loading"}
        />
        <div style={{ height: 25 }}></div>
        <div style={{ width: "80%", marginTop: 20 }}>
          <div style={{ marginLeft: 27, fontSize: 14 }}>
            FIRST LET US KNOW WHAT TYPE OF ASSISTANCE YOU NEED
          </div>
        </div>
        <DropDownWithButton
          width={"97%"}
          marginTop={10}
          data={[
            "SYSTEM",
            "PRESCRIPTION",
            "CUSTOMER",
            "PRODUCT SUGESSTION",
            "OTHER",
          ]}
          title={selectedIssueType}
          setSelected={setSelectedIssueType}
          dropdownHeight={230}
        />
        <div style={{ minHeight: 25 }}></div>
        <TextAreaInput
          mini={true}
          height={200}
          labelTitle={"NOW PROVIDE MORE INFORMATION ON THE ISSUE"}
          color={"#000000"}
          width={"100%"}
          size={"76%"}
          value={issueDescription}
          onChange={(e) => setIssueDescription(e.target.value)}
          // borderRadius={8}
        />
        <div
          style={{
            // flex:
            //   selectedIssueType !== "CLICK HERE TO SELECT TYPE OF ISSUE"
            //     ? 0.5
            //     : 0,
            height: "95%",
            width: "100%",
            transition: "all 0.3s",
          }}
        >
          <div style={{ minHeight: 30 }}></div>
          {selectedIssueType === "SYSTEM ERROR" ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "76%",
                  fontSize: 14,
                }}
              >
                IN WHAT SECTION DID THIS OCCUR ?
              </div>
            </div>
          ) : null}

          {selectedIssueType === "SYSTEM ERROR" ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <DropDownWithButton
                width={"97%"}
                marginTop={10}
                data={[
                  "DASHBOARD",
                  "CUSTOMERS",
                  "PROCESS SALE",
                  "SALES HISTORY",
                  "PROCESS SALE",
                  "SALES REGISTER",
                  "INVENTORY",
                  "PRODUCT INFO",
                  "USER PROFILE",
                  "OTHER",
                ]}
                title={selectedBugType}
                setSelected={setSelectedBugType}
                dropdownHeight={435}
              />
            </div>
          ) : null}
          {selectedIssueType === "SYSTEM ERROR" ? (
            <div style={{ height: 25 }}></div>
          ) : null}
          {selectedIssueType === "SYSTEM ERROR" ? (
            <TextAreaInput
              mini={true}
              height={300}
              labelTitle={"TELL US HOW THS HAPPENED"}
              color={"#000000"}
              width={"100%"}
              size={"76%"}
              value={bugBreakDown}
              onChange={(e) => setBugBreakDown(e.target.value)}
            />
          ) : null}
          {selectedIssueType === "SYSTEM ERROR" ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BaseButtons
                label={"SUBMIT"}
                borderRadius={8}
                mini={true}
                width={"100%"}
                size={"80%"}
                onClick={() => SubmitSupportTicketHandler()}
              />
            </div>
          ) : null}
          {selectedIssueType === "SYSTEM ERROR" ||
          selectedIssueType ===
            "CLICK HERE TO SELECT TYPE OF ISSUE" ? null : selectedIssueType ===
              "PRODUCT SUGESSTION" || selectedIssueType === "OTHER" ? null : (
            <div
              style={{
                width: "100%",
                marginBottom: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  // marginLeft: 15,
                  fontSize: 14,
                  width: "78%",
                }}
              >
                SEARCH AND SELECT CUSTOMER
              </div>
            </div>
          )}
          {selectedIssueType === "SYSTEM ERROR" ||
          selectedIssueType ===
            "CLICK HERE TO SELECT TYPE OF ISSUE" ? null : selectedIssueType ===
              "PRODUCT SUGESSTION" || selectedIssueType === "OTHER" ? null : (
            <div style={{ marginLeft: 0, marginRight: 10, marginBottom: 5 }}>
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  // width: 300,

                  borderWidth: 0.5,
                  width: "100%",
                }}
              >
                <div style={{ width: "78.5%", display: "flex" }}>
                  <TextInputFieldSearch
                    placeholder={"Type here to search"}
                    height={30}
                    borderRadius={4}
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  />
                  <div
                    style={{
                      height: 35,
                      width: 70,
                      backgroundColor: BlackAndWhite.primary,
                      borderRadius: 4,
                      display: "flex",
                      color: BlackAndWhite.secondary,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: 5,
                    }}
                  >
                    <div
                      onClick={() => {
                        setSearch("");
                        setCustomers(null);
                      }}
                      style={{ fontSize: 12, fontWeight: "bold" }}
                    >
                      CLEAR
                    </div>
                  </div>
                  <div
                    style={{
                      height: 35,
                      width: 70,
                      backgroundColor: BlackAndWhite.primary,
                      borderRadius: 4,
                      display: "flex",
                      color: BlackAndWhite.secondary,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: search === "" ? "not-allowed" : "pointer",
                      marginLeft: 10,
                    }}
                  >
                    <div
                      onClick={search === "" ? null : () => OnUserSearch()}
                      style={{
                        fontSize: 12,
                        fontWeight: "bold",
                        opacity: search === "" ? 0.5 : 1,
                      }}
                    >
                      SEARCH
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {selectedIssueType !== "SYSTEM ERROR" &&
          selectedIssueType !== "CLICK HERE TO SELECT TYPE OF ISSUE" ? (
            <div
              style={{
                // flex: 1,
                // overflowY: "auto",
                overflowX: "hidden",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: 30,
                scrollbarWidth: "none",
              }}
            >
              {selectedIssueType === "PRODUCT SUGESSTION" ||
              selectedIssueType === "OTHER" ? null : selectedUser ? (
                <div
                  style={{
                    width: "100%",
                    height: 120,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                >
                  <div
                    onClick={() => setSelectedUser(null)}
                    style={{
                      height: 80,
                      width: "80%",
                      borderRadius: 8,
                      backgroundColor: BlackAndWhite.secondary,
                      WebkitBoxShadow: "0px 0px 12px 5px #00000030",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <img
                      alt="gender"
                      src={require("../../../../../../images/material-icons/profileBlack.png")}
                      style={{
                        height: 35,
                        opacity: 0.6,
                        marginRight: 15,
                        marginLeft: 20,
                      }}
                    />{" "}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: 12,
                        marginRight: 20,
                      }}
                    >
                      <div style={{ marginBottom: 5 }}>
                        {selectedUser.firstName + " " + selectedUser.lastName}
                      </div>
                      <div>{selectedUser.email}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: 12,
                      }}
                    >
                      <div style={{ marginBottom: 5 }}>
                        {selectedUser.idDoc}
                      </div>
                      <div>{selectedUser.cellNumber}</div>
                    </div>
                  </div>
                </div>
              ) : customers ? (
                customers.map((patient, index) => {
                  return (
                    <div key={index} style={{ width: "80%" }}>
                      <PosPatientCard
                        quickSelect={true}
                        firstName={patient ? patient.firstName : "loading"}
                        lastName={patient ? patient.lastName : "loading"}
                        idNum={patient ? patient.idDoc : "loading"}
                        email={patient ? patient.email : "loading"}
                        status={"in progress"}
                        cell={patient ? patient.cellNumber : "loading"}
                        onClick={() => {
                          setSelectedUser(patient);
                        }}
                      />
                    </div>
                  );
                })
              ) : (
                <div
                  style={{ width: "100%", textAlign: "center", marginTop: 40 }}
                >
                  SEARCH FOR USER ABOVE ... WHEN YOUR READY
                </div>
              )}

              {selectedIssueType === "PRODUCT SUGESSTION" ||
              selectedIssueType === "OTHER" ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"SUBMIT"}
                    borderRadius={8}
                    mini={true}
                    width={"100%"}
                    size={"80%"}
                    onClick={() => SubmitSupportTicketHandler()}
                  />
                </div>
              ) : selectedUser ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BaseButtons
                    label={"SUBMIT"}
                    borderRadius={8}
                    mini={true}
                    width={"100%"}
                    size={"80%"}
                    onClick={() => SubmitSupportTicketHandler()}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
          <div style={{ padding: 20 }} />
        </div>
      </div>
    </div>
  );
};

export default SupportModal;
